import * as React from "react";
import appConfig from "../../application/appConfig";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

export interface ILoadingIndicatorProp {
    tooltip?: string;
    classes?: string;
}

export const LoadingIndicator = ({
    classes = "",
    tooltip,
}: ILoadingIndicatorProp) => {
    const { t } = useTranslation();

    return (
        <img
            className={`loading-indicator ${classes}`}
            alt={t("common.loading")}
            title={tooltip || t("common.loading")}
            src={`${appConfig.clientUrl}spinner-loader.gif`}
        />
    );
};


export const LoadingIndicatorInline = ({ classes = "", tooltip }: ILoadingIndicatorProp) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ textAlign: "center", my: 2 }}>
            <img
                className={`loading-indicator-inline ${classes}`}
                alt={t("common.loading")}
                title={tooltip || t("common.loading")}
                src={`${appConfig.clientUrl}spinner-loader.gif`}
            />
        </Box>
    );
};
